import * as yup from "yup";
import {
  fieldMaxLength,
  requiredField,
} from "../../../../../common/infrastructure/helpers/yupHelper";

export const familyWizardFormSchema = yup
  .object({
    id: yup.number().required().defined(),
    studioId: yup.number().required().defined(),

    name: yup
      .string()
      .required(requiredField("Име"))
      .trim()
      .max(200, fieldMaxLength("Име", 200))
      .defined(),

    members: yup.array().required(requiredField("Членове")).defined(),

    headOfFamily: yup.number().nullable().defined(),
  })
  .required();

export type IFamilyWizardFormModel = yup.InferType<
  typeof familyWizardFormSchema
>;

export const familyWizardFormDefaultValues: IFamilyWizardFormModel = {
  id: 0,
  studioId: 0,
  name: "",
  members: [],
  headOfFamily: 0,
};
